import React, { lazy, Suspense } from 'react';
import './App.css';
import { Routes, Route } from 'react-router-dom';

import Navbar from './components/Navbar';
import ScrollToTop from './components/ScrollToTop';
import PageTransitionWrapper from './components/PageTransitionWrapper';
import WhatsAppButton from './components/WhatsAppButton';

import HomePage from './pages/HomePage';

const ServicesPage = lazy(() => import('./pages/ServicesPage'));
const ProjectsPage = lazy(() => import('./pages/ProjectsPage'));
const ProjectDetailPage = lazy(() => import('./pages/ProjectDetailPage'));
const AboutPage = lazy(() => import('./pages/AboutPage'));
const ContactPage = lazy(() => import('./pages/ContactPage'));
const IndustriasPage = lazy(() => import('./pages/IndustriasPage'));
const CareersPage = lazy(() => import('./pages/CareersPage'));
const PoliticaPrivacidadPage = lazy(() => import('./pages/PoliticaPrivacidadPage'));
const TerminosUsoPage = lazy(() => import('./pages/TerminosUsoPage'));
const NotFoundPage = lazy(() => import('./pages/NotFoundPage'));

const AutomotrizPage = lazy(() => import('./pages/AutomotrizPage'));
const BancaPage = lazy(() => import('./pages/BancaPage'));
const MercadosCapitalPage = lazy(() => import('./pages/MercadosCapitalPage'));
const BienesConsumoPage = lazy(() => import('./pages/BienesConsumoPage'));
const EnergiaPage = lazy(() => import('./pages/EnergiaPage'));
const SaludCienciasPage = lazy(() => import('./pages/SaludCienciasPage'));
const SegurosPage = lazy(() => import('./pages/SegurosPage'));
const ManufacturaPage = lazy(() => import('./pages/ManufacturaPage'));
const MediosPage = lazy(() => import('./pages/MediosPage'));
const TecnologiaPage = lazy(() => import('./pages/TecnologiaPage'));
const PetroleoGasPage = lazy(() => import('./pages/PetroleoGasPage'));
const RetailPage = lazy(() => import('./pages/RetailPage'));

const CloudSolutionsPage = lazy(() => import('./pages/CloudSolutionsPage'));
const AnaliticaDatosPage = lazy(() => import('./pages/AnaliticaDatosPage'));
const DisenoPage = lazy(() => import('./pages/DisenoPage'));
const IngenieriaPage = lazy(() => import('./pages/IngenieriaPage'));
const DesarrolloFrontendPage = lazy(() => import('./pages/DesarrolloFrontendPage'));
const EstrategiaInnovacionPage = lazy(() => import('./pages/EstrategiaInnovacionPage'));


function App() {
  return (
    <>
      <a className='vk-skip-link' href='#main'>Saltar al contenido</a>
      <ScrollToTop />
      <Navbar />

      <PageTransitionWrapper>
        <Suspense
          fallback={(
            <div className='route-loading' role='status' aria-live='polite'>
              <span className='route-loading-spinner' aria-hidden='true'></span>
              Cargando contenido…
            </div>
          )}
        >
          <Routes>
          {/* Páginas principales */}
          <Route path='/' element={<HomePage />} />
          <Route path='/servicios' element={<ServicesPage />} />
          <Route path='/proyectos' element={<ProjectsPage />} />
          <Route path='/proyectos/:slug' element={<ProjectDetailPage />} />
          <Route path='/nosotros' element={<AboutPage />} />
          <Route path='/contacto' element={<ContactPage />} />
          <Route path='/industrias' element={<IndustriasPage />} />
          <Route path='/careers' element={<CareersPage />} />
          <Route path='/politica-privacidad' element={<PoliticaPrivacidadPage />} />
          <Route path='/terminos-de-uso' element={<TerminosUsoPage />} />

          {/* Industrias */}
          <Route path='/industrias/automotriz' element={<AutomotrizPage />} />
          <Route path='/industrias/banca' element={<BancaPage />} />
          <Route path='/industrias/mercados-capital' element={<MercadosCapitalPage />} />
          <Route path='/industrias/bienes-consumo' element={<BienesConsumoPage />} />
          <Route path='/industrias/energia' element={<EnergiaPage />} />
          <Route path='/industrias/salud' element={<SaludCienciasPage />} />
          <Route path='/industrias/seguros' element={<SegurosPage />} />
          <Route path='/industrias/manufactura' element={<ManufacturaPage />} />
          <Route path='/industrias/medios' element={<MediosPage />} />
          <Route path='/industrias/tecnologia' element={<TecnologiaPage />} />
          <Route path='/industrias/petroleo' element={<PetroleoGasPage />} />
          <Route path='/industrias/retail' element={<RetailPage />} />

          {/* Servicios */}
          <Route path='/servicios/cloud' element={<CloudSolutionsPage />} />
          <Route path='/servicios/data' element={<AnaliticaDatosPage />} />
          <Route path='/servicios/design' element={<DisenoPage />} />
          <Route path='/servicios/ingenieria' element={<IngenieriaPage />} />
          <Route path='/servicios/frontend' element={<DesarrolloFrontendPage />} />
          <Route path='/servicios/innovacion' element={<EstrategiaInnovacionPage />} />

          <Route path='*' element={<NotFoundPage />} />
          </Routes>
        </Suspense>
      </PageTransitionWrapper>

      <WhatsAppButton />
    </>
  );
}

export default App;
